<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a>The Diary and Observations of Thomas Alva Edison</h1>
<p class="author">Dagobert D. Runes</p>
<div class="img_container1">
<img alt="Images" src="images/PhilosophicalLibrary-Sw_fmt.jpg"/>
</div>
<div class="img_container">
<img alt="Images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?4a123c48